<template>
    <!-- IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы, легенда скрыта): островок кнопок графа — разметка островка AttrGraph: corner-island corner-island-br
         graph-panel-island (справа внизу; corner 'tr' — справа вверху, когда панель команд скрыта), слот — свои кнопки графа перед commandPanel, кнопки commandPanel — <component :is>
         (AttrButton, команды attrFrontMethod / executeVueObjMethod), кнопка легенды — pi pi-tags, «нажата» — attr-graph-btn-on, подписи Show legend / Hide legend, uiHelp — legendHelp.
         Подсказки — v-wjTooltip (по Alt / Show tooltips). Островок AttrGraph пока рисует сам AttrGraph (поведение не менялось) -->
    <div class="corner-island gpi-island" :class="corner === 'tr' ? 'corner-island-tr' : 'corner-island-br graph-panel-island'">
        <slot></slot>
        <component v-for="attrM in buttons"
            :key="attrM.html_id"
            :widget_id="widget_id"
            :is="attrM.component"
            :attr_id="attrM.id"
            :initialAttr="attrM"
        />
        <div class="button-1 p-2" v-if="legendShow" :class="{ 'attr-graph-btn-on': legendOn }"
            v-wjTooltip="legendOn ? t('Hide legend') : t('Show legend')" @click.stop="$emit('legend', !legendOn)" v-uiHelp="{ key: legendHelp, state: () => (legendOn ? 'on' : 'off') }">
            <i class="pi pi-tags"/>
        </div>
        <!-- IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы — поиск, настройки, dragDrop): шестерёнка — разметка AttrGraph (pi pi-cog, Graph settings, после легенды):
             наведение — быстрые настройки (cog-hover, панель — GraphQuickPanel рядом), клик — показать / скрыть их (cog-click) -->
        <div class="button-1 p-2" v-if="cogShow" :class="{ 'attr-graph-btn-on': cogOn }" v-wjTooltip="t('Graph settings')" @click.stop="$emit('cog-click')"
            @mouseenter="$emit('cog-hover', true)" @mouseleave="$emit('cog-hover', false)" v-uiHelp="{ key: cogHelp, state: () => (cogOn ? 'quick' : 'idle') }">
            <i class="pi pi-cog"/>
        </div>
    </div>
</template>

<script>
// IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы, легенда скрыта): см. шаблон; потребитель — AttrSchemeGraphV2 (кнопки — utils/graphPanel.js)
import { t } from '@/i18n'
import { useMainStore } from '@/stores/mainStore'   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: hotfix — пустые граф и матрица связей): store для глобального mixin callgraph (beforeCreate читает this.store.findWidget(widget_id))

export default {
    name: 'GraphPanelIsland',
    setup() { return { store: useMainStore() } },   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: hotfix — пустые граф и матрица связей)
    props: {
        widget_id: [String, Number],
        corner: { type: String, default: 'br' },
        buttons: { type: Array, default: () => [] },
        legendShow: { type: Boolean, default: false },
        legendOn: { type: Boolean, default: false },
        legendHelp: { type: String, default: 'chart.graph.legendBtn' },
        // IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы — поиск, настройки, dragDrop): шестерёнка быстрых настроек
        cogShow: { type: Boolean, default: false },
        cogOn: { type: Boolean, default: false },
        cogHelp: { type: String, default: 'chart.graph.cog' },
    },
    emits: ['legend', 'cog-hover', 'cog-click'],   // IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы — поиск, настройки, dragDrop): + шестерёнка
    methods: { t },
}
</script>

<style>
/* IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы, легенда скрыта): как .attr-graph0 > .corner-island-br / .graph-panel-island у AttrGraph — свой класс, AttrGraph не задет */
.gpi-island.corner-island-br { top: auto !important; bottom: 8px !important; right: 8px !important; left: auto !important; max-width: calc(100% - 16px); flex-wrap: wrap; justify-content: flex-end; }
.gpi-island .p-button, .gpi-island .button-1 { position: static !important; }
.gpi-island .attr-graph-btn-on { background: rgba(47, 59, 82, 0.12); border-radius: 4px; }
</style>
